import { isLogtoEnabled } from '@savgroup-front-common/core/services/isLogtoEnabled';

const { hostname } = window.location;
const logtoClientId = 'jqxuhesirc2et3q5atrrc';

const defaultAuthority = isLogtoEnabled()
  ? 'https://idp-dev.revers.io/oidc'
  : 'https://dev-login.revers.io';

const mapClientIdByHostname: Record<string, string> = isLogtoEnabled()
  ? {}
  : {
      'dev2-app.revers.io': 'dev-field-service-app.revers.io',
      localhost: 'dev-field-service-app.revers.io',
    };

const mapAuthorityByHostname: Record<string, string> = isLogtoEnabled()
  ? {
      localhost: defaultAuthority,
    }
  : {
      localhost: defaultAuthority,
    };

const mapDirectSigningByHostname: Record<string, string> = {};

const AuthConfiguration = {
  authority: mapAuthorityByHostname[hostname] || defaultAuthority,
  clientId: isLogtoEnabled()
    ? mapClientIdByHostname[hostname] || logtoClientId
    : mapClientIdByHostname[hostname] || window.location.hostname,
  scope: isLogtoEnabled()
    ? 'openid email api offline_access profile'
    : 'openid email api',
  direct_sign_in: isLogtoEnabled()
    ? mapDirectSigningByHostname[hostname] || undefined
    : undefined,
};

if (hostname.includes('.dev-control.pages.dev')) {
  AuthConfiguration.clientId = isLogtoEnabled()
    ? logtoClientId
    : 'dev-field-service-app.revers.io';
  AuthConfiguration.authority = defaultAuthority;
}

export default AuthConfiguration;
